<template>
	<div class="library-team-content">
		<div class="online-training-box">
			<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/about/libraryTeam/" />
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components: {
			ssTrainList
		},
		data() {
			return {
				typeList: [{
					value: 'gbtd',
					label: '馆办团队'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.library-team-content{
		.online-training-box{
			background-color: #fff;
			padding: 30px 35px;
			::v-deep .train-list{
				padding-right: 60px;
				.train-item{
					margin-right: 30px;
					width: 33.33333333%;
					&:nth-of-type(4n) {
						float: left;
						margin-right: 30px;
					}
					&:nth-of-type(3n) {
						float: right;
						margin-right: -60px;
					}
				}
			}
		}
	}
</style>
